import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import { initAnalytics, identifyUser, resetAnalytics, trackRoute, analyticsConfigured } from "../lib/analytics";
import { isImpersonating } from "../lib/policyConsentRules";
import * as uxBeacon from "../lib/uxBeacon";

/**
 * 이용 행태 분석(Clarity · PostHog) 마운트 — App.jsx Router 안, UserProvider 아래.
 * 화면을 그리지 않는다. 키(REACT_APP_CLARITY_PROJECT_ID / REACT_APP_POSTHOG_KEY)가 없으면 아무것도 하지 않는다.
 * 규칙은 src/lib/analytics.js 머리 주석 · 기획 docs/ops/lay-ai-operations-plan.md §3-3.
 */
export default function AnalyticsTracker() {
  const location = useLocation();
  const { userInfo } = useUser();
  const email = userInfo?.email || null;
  const role = userInfo?.role || null;

  useEffect(() => { if (analyticsConfigured()) initAnalytics(); }, []);
  // 1차 수집(2026-09-13, src/lib/uxBeacon.js) — REACT_APP_UX_BEACON_URL 이 있을 때만. PostHog 와 별개로 우리 CS DB 에 같은 신호를 보낸다.
  useEffect(() => { uxBeacon.start(); }, []);

  // 로그인 사용자 식별(해시) · 로그아웃 시 리셋. 어드민 「화면 보기」 중에는 식별하지 않는다.
  useEffect(() => {
    if (analyticsConfigured()) {
      if (email) identifyUser({ email, role, impersonating: isImpersonating() });
      else resetAnalytics();
    }
    uxBeacon.identify(email);
  }, [email, role]);

  // 라우트 변경 — 민감 화면은 녹화·자동 수집 중단
  useEffect(() => {
    if (analyticsConfigured()) trackRoute(location.pathname);
    uxBeacon.route(location.pathname);
  }, [location.pathname]);

  return null;
}
